<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <el-form
            ref="form"
            :model="form"
            class="mobile-ruleForm card-ruleForm"
            label-width="104px"
            label-position="left"
          >
            <p class="order-title-boxs"><span class="blueBlock"></span><i>基本信息</i></p>
            <imgUploadHead @file="getFile" :fileList="form.headImgUrl" module="head" :show="true" class="mb20" style="width: 53%;"></imgUploadHead>
            <div class="totals-box pl24">
              
              <div class="flex-row mb30">
                <div class="itemName">姓名</div>
                <div class="itemNum"><el-input v-model="userName" maxlength="10"></el-input></div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">性别</div>
                <div class="itemNum">
                  <el-radio-group v-model="form.gender">
                    <el-radio label="male">男</el-radio>
                    <el-radio label="female">女</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">会员生日</div>
                <div class="itemNum"  v-if="!form.isEditBirthday">{{ form.birthday }}</div>
                <div v-else>
                  <el-date-picker
                    v-model="form.birthday"
                    type="date"
                    :clearable="false"
                    class="w200"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                  </el-date-picker>
                </div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">备注标签</div>
                <div class="itemNum"><el-input v-model="form.memberRemark" maxlength="10"></el-input></div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">注册时间</div>
                <div class="">{{formatDay(form.registerTime)}}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">会员来源</div>
                <div class="">{{form.shopName}}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">手机号码</div>
                <div>
                  <span v-if="form.mobile">{{form.mobile}}</span>
                  <span v-perm="{key:'memberManager', value:'memberManager:updateMobile'}">
                    <span v-if="!form.mobile" @click="updatePsd('mobile')" class="jishi cur">绑定手机号</span>
                    <span v-else @click="updateMobile('mobile')" class="jishi cur ml30">修改</span>
                  </span>
                </div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">身份证号码</div>
                <div><span v-if="form.idCardNo">{{form.idCardNo}}</span><span v-if="!form.idCardNo" v-perm="{key:'memberManager', value:'memberManager:update'}" @click="updatePsd('idCardNo')" class="jishi cur">绑定身份证</span></div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">修改交易密码</div>
                <div class="jishi cur" @click="updatePage" v-perm="{key:'memberManager', value:'memberManager:updatePwd'}">修改</div>
              </div>
            </div>
          </el-form>
        </div>
        <el-dialog
          :title="toggleHide ? '绑定手机号码':'绑定身份证'"
          :visible.sync="centerDialogVisible"
          width="620px"
          append-to-body
          :close-on-click-modal='false'
        >
          <el-form ref="form" label-position="right" :model="form"  label-width="120px">
            <el-form-item
              class="flex-row"
              ref="realName"
              label="姓名："
              prop="realName"
              v-if="!toggleHide"
            >
              <el-input v-model="updateForm.realName" placeholder="请输入真实姓名" maxlength="5"></el-input>
            </el-form-item>
            <el-form-item class="flex-row" ref="idCardNo" label="身份证号码：" prop="idCardNo" v-if="!toggleHide">
              <el-input v-model="updateForm.idCardNo" placeholder="请输入身份证号码" maxlength="18"></el-input>
            </el-form-item>
            <el-form-item
              v-if="!toggleHide"
              class="item-cards"
              ref="idCardFrontUrl"
              prop="idCardFrontUrl"
              label="身份证照片："
            >
              <div class="flex-row">
                <div class="front card-box mr20">
                  <imgUpload
                    @file="getFileCardFront"
                    :fileList="idCardFrontUrl"
                    module="idcard"
                  ></imgUpload>
                  <p class="divCenter">身份证正面照</p>
                </div>
                <div class="back card-box">
                  <imgUpload @file="getFileCarBack" :fileList="idCardBackUrl" module="idcard"></imgUpload>
                  <p class="divCenter">身份证反面照</p>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="手机号码：" class="flex-row" v-if="toggleHide">
              <!-- <span v-if="form.mobile">{{form.mobile}}</span> -->
              <el-input v-model="updateForm.mobile" placeholder="请输入手机号码" maxlength="11"></el-input>
              <!-- {{this.userInfo.mobile}} -->
            </el-form-item>
            <el-form-item label="手机号码：" class="flex-row" v-else>
              <span v-if="form.mobile">{{form.mobile}}</span>
              <!-- {{this.userInfo.mobile}} -->
            </el-form-item>
            <el-form-item label="短信验证码：" prop="verifyCode" class="flex-row">
              <div class="sms-input">
                <el-input placeholder="请输入验证码" v-model="updateForm.verifyCode" maxlength="6"></el-input>
                <el-link type="primary" @click="addLoginCode" :disabled="!codeName" class="sms-code">{{ codeName ? '获取验证码':time+'s'}}</el-link>
              </div>
            </el-form-item>
          </el-form>

          <span slot="footer" class="dialog-footer">
            <el-button @click="calcel">取 消</el-button>
            <el-button type="primary" @click="updateSubmit">确 定</el-button>
          </span>
        </el-dialog>
        <div class="drawer-footer">
          <div class="pr24 pb10">
            <el-button @click="back">取消</el-button>
            <el-button type="primary" @click="onSubmit">保存</el-button>
          </div>
        </div>
      </div>
    </drawer>
    <update-pwd ref="updatePwdSetForm" ></update-pwd>
    <update-mobile ref="updateMobile" @handleChange="onChange"></update-mobile>
  </div>
</template>

<script>
import imgUpload from "../../components/common/modules/uploads";
import imgUploadHead from "../../components/common/modules/upload-head";
import minxin from "../../assets/javascript/minxin.js";
import drawer from "../../components/common/drawer";
import updatePwd from "./updatePwd";
import updateMobile from "./updateMobile";
import { decrypt, encrypt } from "../../assets/javascript/untils";
export default {
  mixins: [minxin],
  components: { drawer, imgUpload,updatePwd,updateMobile,imgUploadHead },
  data() {
    return {
      mobileLoginIn: true,
      centerDialogVisible: false,
      toggleHide: true,
      codeName: true,
      time: 60,
      userName: '',
      addEditTitle: "会员管理 > 新增会员",
      addEditShow: false,
      form: {
        id: "",
        headImgUrl: "", // 头像
        nickName: "", //真实姓名
        mobile: "", //手机号码
        idCardNo: "", //身份证号码
        idCardFrontUrl: "", //身份证正面照片
        idCardBackUrl: "", //身份证反面照片
        gender: "male", //性别,male为男,female为女
        level: "", //等级 默认0
        password: "", //密码
        comfirmPassword: "" //确认密码
      },
      updateForm: {
        idCardFrontUrl: "", //身份证正面照片
        idCardBackUrl: "", //身份证反面照片
      },
      idCardFrontUrl: '',
      idCardBackUrl: '',
      columns: [],
      staffList: [],
      cardOldName: "",
      showPicker: false
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    back() {
      this.addEditShow = false;
      this.$emit("change", true);
      this.$refs['form'].resetFields()
    },
    editInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        if (org) {
          this.mobileLoginIn = false;
          this.toggleHide = false;
          this.getMemberInfo(org.id);
          this.addEditTitle = "修改资料";
        }
      });
    },
    getMemberInfo (id) {
      this.$api.get(this.$url.member.get, {
        id: id
      }).then(res => {
        if (res) {
          this.addEditShow = true;
          this.form = res;
          this.form.memberId = res.id;
          this.userName = this.form.nickName;
          this.form.birthday = this.form.birthday ? this.formatDay(this.form.birthday) : '';
        }
      })
    },
    updatePsd (item) {
      this.centerDialogVisible = true
      if (item == 'mobile') {
        this.toggleHide = true
      } else {
        this.toggleHide = false
      }
    },
    updateMobile () {
      console.log(this.form);
        // 修改手机号
        this.$refs["updateMobile"].$emit("set", {id: this.form.id, mobile: this.form.mobile});
    },
    // 上传组件成功回调
    getFile(res) {
      if (!this.form.id && this.form.headImgUrl) {
        this.ossMerchatDelImg({imgUrl: this.form.headImgUrl});
      }
      this.form.headImgUrl = res;
    },
    getFileCardFront(res) {
      //身份证正面
      // this.updateForm.idCardFrontUrl = res;
      if (!this.updateForm.id && this.updateForm.idCardFrontUrl) {
        this.ossMerchatDelImg({imgUrl: this.updateForm.idCardFrontUrl});
      }
      this.updateForm.idCardFrontUrl = res.oldImgUrl;
      this.idCardFrontUrl = res.newImgUrl;
    },
    getFileCarBack(res) {
      //身份证反面
      // this.updateForm.idCardBackUrl = res;
      if (!this.updateForm.id && this.updateForm.idCardBackUrl) {
        this.ossMerchatDelImg({imgUrl: this.updateForm.idCardBackUrl});
      }
      this.updateForm.idCardBackUrl = res.oldImgUrl;
      this.idCardBackUrl = res.newImgUrl;
    },
    handleChangeDrawer() {
      this.$refs["form"].clearValidate();
      this.addEditShow = false;
      this.$emit("change", false);
    },
    onChange (org) {
      if (org) this.getMemberInfo(this.form.id)
    },
    addLoginCode(type) {
      if (!this.toggleHide) {
        this.updateForm.mobile = this.form.mobile
      } 
      if (this.updateForm.mobile == "") {
        this.$message.error("请输入手机号码");
        return false;
      }
      if (this.updateForm.mobile.length != 11) {
        this.$message.error("请输入正确的手机号码");
        return false;
      }

      let arr = encrypt(
        JSON.stringify({
          mobile: this.updateForm.mobile,
          bizType: "memberUpInfo",
          millisecond: new Date().getTime()
        })
      );
      this.$api.post(this.$url.send, arr).then(resp => {
        if (resp) {
          this.codeName = false;
          this.$message.success("短信发送成功")
        } else {
          this.codeName = true;
          clearInterval(auth_timetimer);
        }
        this.time = 60;
      });
      let auth_timetimer = setInterval(() => {
        if (this.time <= 0) {
          this.time = 60;
          this.codeName = true;
          clearInterval(auth_timetimer);
        }
        this.time--;
      }, 1000);
    },
    getMember () {
      this.$api.get(this.$url.member.get, {
        id: this.form.id
      }).then(res => {
        if (res) {
          this.form = res;
          this.form.memberId = res.id;
          this.userName = this.form.nickName
        }
      })
      .catch(error => {});
    },
    updateSubmit () {
      if (this.toggleHide) {
        //  绑定手机号
        if (!this.updateForm.mobile) {
          this.$message.error("请输入手机号码");
          return false;
        } else if (this.updateForm.mobile.length != 11) {
          this.$message.error("请输入正确的手机号码");
          return false;
        } else if (!this.updateForm.verifyCode) {
          this.$message.error("请输入验证码");
          return false;
        }
        this.form.mobile = this.updateForm.mobile
        this.form.verifyCode = this.updateForm.verifyCode
        // bindMobile
        this.$api.post(this.$url.member.bindMobile, this.form ).then(res => {
            if (res) {
              this.centerDialogVisible = false;
              this.$message.success("绑定成功");
              this.getMember();
            }
          })
          .catch(error => {});
      } else {
        //  绑定身份证
        if (!this.updateForm.idCardNo) {
          return this.$message.error("请填写身份证号码");
        } else if (!this.updateForm.idCardFrontUrl) {
          return this.$message.error("请上传身份证正面照");
        } else if (!this.updateForm.idCardBackUrl) {
          return this.$message.error("请上传身份证反面照");
        } else if (!this.updateForm.verifyCode) {
          this.$message.error("请输入验证码");
          return false;
        }
        this.form.realName = this.updateForm.realName 
        this.form.idCardNo = this.updateForm.idCardNo
        this.form.idCardFrontUrl = this.updateForm.idCardFrontUrl
        this.form.idCardBackUrl = this.updateForm.idCardBackUrl
        this.form.verifyCode = this.updateForm.verifyCode
        // bindIdCard
         this.$api.post(this.$url.member.bindIdCard, this.form ).then(res => {
            if (res) {
              this.centerDialogVisible = false;
              this.$message.success("绑定成功");
              this.getMember();
            }
          })
          .catch(error => {});
      }
    },
    calcel () {
      this.updateForm = {}
      this.centerDialogVisible = false
    },
    onSubmit(values) {
      if (!this.userName) {
        return this.$message.error("请输入会员名")
      }
      console.log({
        millisecond: new Date().getTime(),
        memberId: this.form.memberId,
        gender: this.form.gender,
        nickName: this.userName,
        birthday: this.form.birthday,
        memberRemark: this.form.memberRemark,
        headImgUrl: this.form.headImgUrl
      });
      let parmar = encrypt(JSON.stringify({
        millisecond: new Date().getTime(),
        memberId: this.form.memberId,
        gender: this.form.gender,
        nickName: this.userName,
        birthday: this.form.birthday,
        memberRemark: this.form.memberRemark,
        headImgUrl: this.form.headImgUrl
      }));
      this.$refs.form.validate((valid, object) => {
        if (valid) {
            this.$api.post(this.$url.member.updateMemberInfo, parmar).then(res => {
                if (res) {
                  this.addEditShow = false;
                  this.$message.success("操作成功");
                  this.$emit("change", true);
                }
              })
              .catch(error => {});
        }
      });
    },
    updatePage() { // 修改密码
      this.$refs["updatePwdSetForm"].$emit("set", this.form);
    },
  }
};
</script>
<style scoped lang="less">
@import "../../assets/css/edit.less";
/deep/ .el-form-item__content {
  margin-left: 0 !important;
}
.sms-input {
  position: relative;
  .sms-code {
    position: absolute;
    right: 10px;
  }
}
</style>